import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { fragmentsPermissions } from '@mi-front/api-clients';
import { Alert, Box, Grid } from '@mui/material';
import { Title } from '@ui/components';
import { FormattedMessage } from 'react-intl';
import { audiogramHelpers } from '../helpers';
import { AudiogramMediaPreview } from './AudiogramMediaPreview';
import { AudiogramSocialExportAllPlatforms } from './AudiogramSocialExportAllPlatforms';
import { useFragment } from '../../../hooks/useFragment';

export function AudiogramExport() {
  const { fragment } = useFragment();
  const completedVariants = audiogramHelpers.getCompletedVariants(fragment);

  if (!completedVariants.length) {
    return null;
  }

  return (
    <Box>
      <Title className="mb-3 font-size-base">
        <FormattedMessage id="audiogram.exportAudiogram" defaultMessage="Exportar audiogram" />
      </Title>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <IfPermission
            permission={fragmentsPermissions.Fragments_SocialPublish}
            cant={
              <Alert severity="warning">
                <FormattedMessage
                  id="audiogram.noPermissionSocialExport"
                  defaultMessage="No tienes permisos para exportar a redes sociales"
                />
              </Alert>
            }
          >
            <AudiogramSocialExportAllPlatforms />
          </IfPermission>
        </Grid>
        <Grid item xs={12} md={6}>
          <AudiogramMediaPreview />
        </Grid>
      </Grid>
    </Box>
  );
}
